import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSiteMode } from '../../contexts/SiteModeContext';
import { TestingBanner } from './TestingBanner';

const PUBLIC_PATHS = ['/', '/terms', '/privacy', '/contact', '/testing', '/admin', '/unsubscribe'];
const INDEXABLE_PATHS = ['/', '/terms', '/privacy', '/contact'];

const normalise = (p) => (p.length > 1 ? p.replace(/\/+$/, '') : p);

const useRobotsMeta = (noindex) => {
  useEffect(() => {
    let el = document.querySelector('meta[name="robots"]');
    if (noindex) {
      if (!el) { el = document.createElement('meta'); el.setAttribute('name', 'robots'); document.head.appendChild(el); }
      el.setAttribute('content', 'noindex');
    } else if (el) {
      el.remove();
    }
  }, [noindex]);
};

export const SiteGate = ({ children }) => {
  const { loading, mode, isTester, isAdmin, refresh } = useSiteMode();
  const path = normalise(useLocation().pathname);
  const founding = mode === 'founding';

  useEffect(() => { if (!loading) refresh(); }, [path]); // eslint-disable-line react-hooks/exhaustive-deps
  useRobotsMeta(founding && !INDEXABLE_PATHS.includes(path));

  if (loading) return null;
  if (founding && !isTester && !isAdmin && !PUBLIC_PATHS.includes(path)) return <Navigate to="/" replace />;
  return (
    <>
      {founding && isTester && <TestingBanner />}
      {children}
    </>
  );
};

export const HomeRoute = ({ landing, founding }) => {
  const { mode, isTester } = useSiteMode();
  return mode === 'founding' && !isTester ? founding : landing;
};
